import { render, staticRenderFns } from "./mail-confirm-waiting.vue?vue&type=template&id=409fac60&scoped=true&"
import script from "./mail-confirm-waiting.vue?vue&type=script&lang=ts&"
export * from "./mail-confirm-waiting.vue?vue&type=script&lang=ts&"
import style0 from "./mail-confirm-waiting.vue?vue&type=style&index=0&id=409fac60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409fac60",
  null
  
)

export default component.exports